export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-background-800 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="font-heading text-xl font-bold text-white mb-4">91黑料</div>
            <p className="text-sm text-background-300 leading-relaxed">
              国内领先的娱乐八卦与热点资讯聚合平台。每日实时更新最新黑料视频，提供最新黑料网站入口与在线观看地址。快速访问91黑料，看劲爆黑料视频。
            </p>
          </div>

          <div>
            <div className="font-heading text-base font-bold text-white mb-4">快速导航</div>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热门爆料', href: '#cards' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热度榜单', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="font-heading text-base font-bold text-white mb-4">主题分类</div>
            <div className="flex flex-col gap-2.5">
              {['明星八卦', '网红爆料', '综艺内幕', '社会热点', '品牌翻车'].map((label) => (
                <a
                  key={label}
                  href="#index"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick('#index');
                  }}
                  className="text-sm text-background-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="font-heading text-base font-bold text-white mb-4">合作伙伴</div>
            <p className="text-sm text-background-300 leading-relaxed">
              本站与多家优质内容平台及媒体渠道保持合作关系，共同为用户提供高质量的资讯内容服务。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 91黑料 - 91黑料网在线观看与黑料网站入口。本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-6 text-xs text-background-400">
            <span className="cursor-pointer hover:text-background-200 transition-colors whitespace-nowrap">使用条款</span>
            <span className="cursor-pointer hover:text-background-200 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-200 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}